module.exports = __webpack_public_path__ + "img/37.02a9836d.png";